import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import { useDispatch } from 'react-redux';
import withEventCardSkeleton from 'modules/event-cards/skeleton/with-event-card-skeleton.js';
import BannerCardDetails from 'modules/event-cards/banner/banner-card-details/index.js';
import BannerCardTypes from 'modules/event-cards/banner/types.js';
import EventCardBadge from 'modules/event-cards/badge/index.js';

const intentActions = MojitoCore.Intents.actions;
const IntentTypes = MojitoPresentation.Base.Intent.Types;
const { FlexPane, Image, Button } = MojitoPresentation.Components;
const { BANNER_CARD_MODES } = BannerCardTypes;

const BannerCard = withEventCardSkeleton(
    props => {
        const dispatch = useDispatch();
        const {
            mojitoTools,
            imgUrl,
            targetUrl,
            openInNewTab,
            onLoadDone,
            elementRef,
            altText,
            cardBannerDetails,
            locationId,
        } = props;

        const {
            config,
            style,
            appContext: {
                analyticsEmitter: { emitAnalytics },
            },
        } = mojitoTools;

        const onClick = targetUrl => {
            emitAnalytics('promotionClicked', { locationId, bannerName: altText });
            dispatch(
                intentActions.publishIntent(IntentTypes.OPEN_URL, {
                    url: targetUrl,
                    ...(openInNewTab && { windowName: '' }),
                })
            );
        };

        const bannerMode =
            BANNER_CARD_MODES[cardBannerDetails?.colorMode] || config.defaultBannerMode;
        const bannerCardDetailsConfig =
            bannerMode === BANNER_CARD_MODES.LIGHT
                ? config.lightBannerCardDetails
                : style.darkBannerCardDetails;

        const isButtonDisabled = !!(
            cardBannerDetails?.primaryButton?.link || cardBannerDetails?.secondaryButton?.link
        );

        const extraButtonProps = isButtonDisabled
            ? {}
            : {
                  onClick: () => onClick(targetUrl),
                  hrefLink: targetUrl,
              };

        return (
            <FlexPane
                config={config.eventCard.container}
                elementRef={elementRef}
                class="ta-BannerCard"
            >
                <Button
                    config={config.eventCard.clickableArea}
                    class="ta-BannerCardButton"
                    disabled={isButtonDisabled}
                    {...extraButtonProps}
                >
                    {config.showBadgeRow && (
                        <FlexPane class="ta-badgeRow" config={config.badgeRow}>
                            <EventCardBadge config={config.categoryBadge} />
                            <EventCardBadge config={config.secondaryBadge} />
                        </FlexPane>
                    )}
                    <Image
                        src={imgUrl}
                        config={config.bannerImage}
                        onLoad={onLoadDone}
                        onError={onLoadDone}
                        alt={altText}
                    />
                    {cardBannerDetails && (
                        <BannerCardDetails
                            config={bannerCardDetailsConfig}
                            onClick={onClick}
                            cardBannerDetails={cardBannerDetails}
                        />
                    )}
                </Button>
            </FlexPane>
        );
    },
    () => false,
    config => config.eventCard.skeletonLoader
);

BannerCard.getStyle = (config, mode, merge) => ({
    darkBannerCardDetails: merge(config.lightBannerCardDetails, config.darkBannerCardDetails),
});

export default BannerCard;
